(function() {
    const archiveEl = document.body.querySelector('.jsArchive');
    let archiveGrid = null;
    let currentPage = 1;
    let searchTimeout = null;
    let searchQuery = '';
    let postType = 'post';

    if (archiveEl) {
        postType = typeof archiveEl.dataset.postType !== 'undefined' ? archiveEl.dataset.postType : 'post';
        archiveGrid = archiveEl.querySelector('.jsArchiveGrid');

        const contentTypeFilterEl = archiveEl.querySelector('.jsContentTypeFilter');
        if (contentTypeFilterEl) {
            const contentTypeSelect = new SeSelect(contentTypeFilterEl, 'type');
            contentTypeSelect.setActiveOptions(activeContentTypes);

            contentTypeSelect.addChangeEventListener(newOptions => {
                activeContentTypes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const yearFilterEl = archiveEl.querySelector('.jsYearFilter');
        if (yearFilterEl) {
            const yearSelect = new SeSelect(yearFilterEl, 'y');
            yearSelect.setActiveOptions(activeYears);

            yearSelect.addChangeEventListener(newOptions => {
                activeYears = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const themeFilterEl = archiveEl.querySelector('.jsThemeFilter');
        if (themeFilterEl) {
            const themeSelect = new SeSelect(themeFilterEl, 'theme');
            themeSelect.setActiveOptions(activeThemes);

            themeSelect.addChangeEventListener(newOptions => {
                activeThemes = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const programFilterEl = archiveEl.querySelector('.jsProgramFilter');
        if (programFilterEl) {
            const programSelect = new SeSelect(programFilterEl, 'program');
            programSelect.setActiveOptions(activePrograms);

            programSelect.addChangeEventListener(newOptions => {
                activePrograms = Object.keys(newOptions);
                currentPage = 1;
                updateGrid();
            });
        }

        const searchFormEl = archiveEl.querySelector('.jsSearchFilter');
        if (searchFormEl) {
            const searchInputEl = searchFormEl.querySelector('input');

            searchFormEl.addEventListener('submit', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });

            searchInputEl.addEventListener('keyup', e => {
                e.preventDefault();
                userDidSearch(searchInputEl.value);
            });
        }
    }

    function userDidSearch(query) {
        searchQuery = query;

        // Update the URL
        const url = new Url;

        if (searchQuery) url.query.search = searchQuery;
        else delete url.query.search;

        history.pushState(null, null, url.toString());

        // Set a timeout
        if (searchTimeout) clearTimeout(searchTimeout);
        searchTimeout = setTimeout(_ => updateGrid(), 500);
    }

    function updateGrid() {
        const params = {
            action: 'get_story_grid_html',
            activeContentTypes: activeContentTypes,
            searchQuery: searchQuery,
            pageNumber: currentPage,
            baseUrl: archiveUrl + window.location.search,
            postType: postType
        };

        if (typeof activeYears !== 'undefined') params.activeYears = activeYears;
        if (typeof activeThemes !== 'undefined') params.activeThemes = activeThemes;
        if (typeof activePrograms !== 'undefined') params.activePrograms = activePrograms;

        se_postRequest(se_ajax.ajaxurl, params, response => {
            response = JSON.parse(response);

            if (!response.err) {
                archiveGrid.innerHTML = response.html;
            }
            else {
                alert('Oops.. Something went wrong. Please reload the page and try again.');
                return;
            }

        }, _ => {
            alert('Oops.. Something went wrong. Please reload the page and try again.');
            return;
        });
    }
})();
